import { TestVisualizationProps, VisualizationMetrics } from "@/common/types";
import MultiLevelProgressBar from "@/components/multi-level-progress-bar";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useEffect, useState } from "react";

const TestVisualization: React.FC<TestVisualizationProps> = ({
  visualization,
}) => {
  const [visualizationMetrics, setVisualizationMetrics] = useState<
    VisualizationMetrics[]
  >([]);

  useEffect(() => {
    const data = visualization.metrics?.map((metric) => {
      return {
        name: metric.name,
        indicator: {
          value: metric.user_value,
          viz_value: metric.viz_user_value,
        },
        levels: metric.measurement_ranges.map((range) => {
          return {
            label: range.evaluation,
            color: `#${range.range_color}`,
            value: range.range_upper,
            value_lower: range.range_lower,
            viz_value: range.viz_range_upper,
          };
        }),
      };
    });
    setVisualizationMetrics(data);
  }, [visualization]);

  return (
    <Tabs defaultValue="taxa">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="taxa">Taxa</TabsTrigger>
        <TabsTrigger value="metrics">Metrics</TabsTrigger>
      </TabsList>

      <TabsContent value="taxa">
        <ScrollArea className="h-[300px] md:h-[calc(100vh-400px)] overflow-auto">
          {visualization.taxa?.map((taxaDetail, index) => (
            <div key={index} className="grid grid-cols-4 gap-1 px-4 py-2">
              <div className="col-span-2">{taxaDetail.taxonomy_name}</div>
              <div>{taxaDetail.classified_relative_abundance}</div>
              <div
                style={{
                  backgroundColor: `#${
                    taxaDetail.category_gut_color || "000000"
                  }`,
                }}
                className={`py-1 px-2 rounded-md ${
                  taxaDetail.category_gut === "" ||
                  "Unknown" === taxaDetail.category_gut
                    ? "text-white"
                    : "text-black"
                }`}
              >
                {taxaDetail.category_gut || "NA"}
              </div>
            </div>
          ))}
        </ScrollArea>
      </TabsContent>

      <TabsContent value="metrics">
        <ScrollArea className="h-[300px] md:h-[calc(100vh-400px)] overflow-auto">
          {visualizationMetrics?.map((metric, index) => (
            <div key={index} className="px-4 py-2 pb-2 border-t">
              <div>{metric.name}</div>
              <div>
                <MultiLevelProgressBar
                  levels={metric.levels}
                  indicator={metric.indicator}
                />
              </div>
            </div>
          ))}
        </ScrollArea>
      </TabsContent>
    </Tabs>
  );
};

export default TestVisualization;
